import Service from "../Service";

const resource = "hmnAgreement/";

export default {
    // pagination(parameters, requestID) {
    //     // console.time("Tiempo de paginado");
    //     return Service.post(resource + "pagination", parameters, {
    //         params: {
    //             requestID: requestID,
    //         },
    //     });
    // },
    async pagination(parameters, requestID) {
        const startTime = performance.now(); // Inicia el cronómetro (en ms)
        console.log("⌛ Iniciando petición de paginado...");

        try {
            const response = await Service.post(resource + "pagination", parameters, {
                params: { requestID },
            });

            const endTime = performance.now();
            const durationInSeconds = (endTime - startTime) / 1000; // Convertir a segundos
            console.log(`✅ Paginado recibido en ${durationInSeconds.toFixed(3)}s`); // 3 decimales
            return response;

        } catch (error) {
            const endTime = performance.now();
            const durationInSeconds = (endTime - startTime) / 1000;
            console.error(`❌ Error después de ${durationInSeconds.toFixed(3)}s`, error);
            throw error;
        }
    },
    workerPerson(WkrID, AgtID, requestID, isWorkerView = false) {

        return Service.post(
            resource + "workerPerson", {}, {
            params: { WkrID: WkrID, AgtID: AgtID, requestID: requestID, isWorkerView: isWorkerView },
        }
        );
    },
    workerByNtpID(NtpID, requestID) {
        return Service.post(
            resource + "workerByNtpID", {}, {
            params: { NtpID: NtpID, requestID: requestID },
        }
        );
    },
    searchContractByWkrID(WkrID, requestID) {
        return Service.post(resource + "contractByWkrID", {}, {
            params: { WkrID: WkrID, requestID: requestID },
        }
        );
    },
    /** Alias: trae los últimos contratos de un trabajador para el timeline */
    HmnContractByWkrID(WkrID, requestID) {
        return Service.post(resource + "contractListByWkrID", {}, {
            params: { WkrID: WkrID, requestID: requestID },
        });
    },
    /** Trae los movimientos de un contrato específico */
    movementsByAgtID(AgtID, requestID) {
        return Service.post(resource + "movementsByAgtID", {}, {
            params: { AgtID: AgtID, requestID: requestID },
        });
    },
    contractSourceByDocument(prsDocumentNumber) {
        return Service.get(resource + "contractSourceByDocument", {
            params: { prsDocumentNumber },
        });
    },
    contractAutomationByDocument(prsDocumentNumber, evaluationDate) {
        const params = { prsDocumentNumber };
        if (evaluationDate) {
            params.evaluationDate = evaluationDate;
        }
        return Service.get(resource + "contractAutomationByDocument", {
            params,
        });
    },

    create(ntp, requestID) {
        return Service.post(resource + "create", ntp, {
            params: { usrID: requestID },
        });
    },
    Positionlist(parameters, requestID) {
        return Service.post(resource + "Positionlist", parameters, {
            params: { requestID: requestID },
        });
    },
    captureFingerprint() {
        return Service.post(resource + "startfingerprintcapture")
            .then(response => {

                return response.data;
            })
            .catch(error => {
                console.error("Error capturing fingerprint:", error);
                throw error;
            });
    },
    InitialFingerprint(parameters, requestID) {
        console.log("parameters en el servicio:", parameters, requestID);

        return Service.post(resource + "initializefingerprint", parameters, {
            params: { requestID: requestID },
        });
    },
    closeDevice() {
        return Service.post(resource + "close")
            .then(response => {
                return response.data;
            })
            .catch(error => {
                console.error("Error closing the device:", error);
                throw error;
            });
    },
    FingerPrintListBy(document, requestID) {
        console.log("document en el servicio:", document, requestID);

        return Service.post(
            resource + "FingerprintTempByDni", {}, {
            params: { document: document, requestID: requestID },
        }
        );
    },
    FingerprintByNtp(NtpID, requestID) {
        return Service.post(
            resource + "FingerprintByNtpID", {}, {
            params: { NtpID: NtpID, requestID: requestID },
        }
        );
    },
    IPListByUsrID(UsrID, requestID) {
        return Service.post(
            resource + "IPListByUsrID", {}, {
            params: { UsrID: UsrID, requestID: requestID },
        }
        );
    },
    saveUserIp(obj, requestID) {
        return Service.post(resource + "saveUserIp", obj, {
            params: { requestID: requestID },
        });
    },
    saveFingerTemp(obj, requestID) {
        return Service.post(resource + "saveFingerTemp", obj, {
            params: { requestID: requestID },
        });
    },

    searchContract(AgtID, requestID) {
        return Service.post(
            resource + "searchContract", {}, {
            params: { AgtID: AgtID, requestID: requestID },
        }
        );
    },

    savePrint(items, requestID) {
        return Service.post(
            resource + "savePrint", items, {
            params: { requestID: requestID },
        }
        );
    },

    SaveFingerprints(obj, requestID) {
        return Service.post(resource + "SaveFingerprints", obj, {
            params: { requestID: requestID },
        });
    },

    closefingerprint(requestID) {
        return Service.post(resource + "closefingerprint", {}, {
            params: { requestID: requestID },
        });
    },
    requirementVacancyStatus(params, requestID) {
        const queryParams = {};
        if (requestID) queryParams.requestID = requestID;
        if (typeof params === "object" && params !== null) {
            const rId = params.reqID || params.ReqID;
            const cId = params.cmpID || params.CmpID;
            const pId = params.pstID || params.PstID;
            const aId = params.agtID || params.AgtID;
            if (rId && Number(rId) > 0) queryParams.reqID = Number(rId);
            if (cId && Number(cId) > 0) queryParams.cmpID = Number(cId);
            if (pId && Number(pId) > 0) queryParams.pstID = Number(pId);
            if (aId && Number(aId) > 0) queryParams.agtID = Number(aId);
        } else if (params && Number(params) > 0) {
            queryParams.reqID = Number(params);
        }
        return Service.get(resource + "requirementVacancyStatus", {
            params: queryParams,
        });
    },
    candidatesByRequirement(reqID, requestID) {
        return Service.get(resource + "candidatesByRequirement", {
            params: { reqID, requestID },
        });
    },
    saveMassive(loteData, requestID) {
        return Service.post(resource + "saveMassive", loteData, {
            params: { requestID },
        });
    },
    listContracts(params, requestID) {

        console.log("listContracts", params);

        return Service.get(resource + "listContracts", {
            params: { agtStatus: params.agtStatus, search: params.search, requestID: requestID },
        });
    },
    deleteMovement(amsID, requestID) {
        return Service.post(resource + "deleteMovement", {}, {
            params: { amsID: amsID, requestID: requestID },
        });
    },
    save(obj, requestID) {
        return Service.post(resource + "save", obj, {
            params: { requestID: requestID },
        });
    },
    saveFull(payload, requestID) {
        return Service.post(resource + "saveFull", payload, {
            params: { requestID: requestID },
        });
    },
    trackingList(params, requestID) {
        return Service.get(resource + "trackingList", {
            params: { ...params, requestID: requestID },
        });
    },
    trackingInsert(tracking, requestID) {
        return Service.post(resource + "trackingInsert", tracking, {
            params: { requestID: requestID },
        });
    },
    workerFinancialData(wkrID, requestID) {
        console.log("workerFinancialData", wkrID, requestID);

        return Service.get(resource + "workerFinancialData", {
            params: { wkrID, requestID },
        });
    },
    validateMassiveWorkers(req, requestID) {
        return Service.post(resource + "validateMassiveWorkers", req, {
            params: { requestID: requestID },
        });
    },
    saveMassiveContracts(req, requestID) {
        return Service.post(resource + "saveMassiveContracts", req, {
            params: { requestID: requestID },
        });
    },
    saveMassiveRenewalsExtensions(req, requestID) {
        return Service.post(resource + "saveMassiveRenewalsExtensions", req, {
            params: { requestID: requestID },
        });
    },
    downloadMassiveContractsPdf(req, requestID) {
        return Service.post(resource + "massivePrintPdf", req, {
            params: { requestID: requestID },
            responseType: "blob",
        });
    },
};